import React, { Fragment, useContext } from 'react';
import * as input from '../connectedForm/inputComponents';
import { default as Form } from '../connectedForm';
import ColumnLabel from '../connectedForm/ColumnLabel/ColumnLabel';
import Label from '../connectedForm/Label/Label';
import getIn from '../connectedForm/utils/getIn';
import ConnectedFormContext from '../Context/ConnectedFormContext';

const VatBreakdown = () => {
  const { values } = useContext(ConnectedFormContext);

  const breakdownList = getIn(values, 'vatSummary.vatRateBreakdownList');
  const breakdownArray = [];

  if (!breakdownList) return null;

  breakdownList.forEach((breakdown, index) => {
    breakdownArray.push(
      <Fragment key={`vatBreakdown${index}`}>
        <Form.Row>
          <Form.Fieldset cols={1 / 3} collapsed={true}>
            <Form.Field
              value={breakdown.vatRate.rate}
              datatype="numeric"
              component={input.BlurTextField}
              readOnly={true}
              decimals={2}
              includeLabel={false}
            />
          </Form.Fieldset>
          <Form.Fieldset cols={1 / 3} collapsed={true}>
            <Form.Field
              value={breakdown.goods}
              datatype="numeric"
              component={input.BlurTextField}
              readOnly={true}
              includeLabel={false}
              type={'currency'}
            />
          </Form.Fieldset>
          <Form.Fieldset cols={1 / 3} collapsed={true}>
            <Form.Field
              value={breakdown.vat}
              datatype="numeric"
              component={input.BlurTextField}
              readOnly={true}
              includeLabel={false}
              type={'currency'}
            />
          </Form.Fieldset>
        </Form.Row>
      </Fragment>
    );
  });

  return (
    <Fragment>
      <Form.Legend label="VAT Breakdown" />
      <Form.Row>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <ColumnLabel label={'Rate'} textAlign={'right'} />
        </Form.Fieldset>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <ColumnLabel label={'Goods & Carriage'} textAlign={'right'} />
        </Form.Fieldset>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <ColumnLabel label={'VAT'} textAlign={'right'} />
        </Form.Fieldset>
      </Form.Row>
      {breakdownArray}
    </Fragment>
  );
};

const ValueBreakdown = () => {
  return (
    <>
      <Form.Legend label="Value Breakdown" />

      <Form.Row>
        <Form.Fieldset cols={1 / 3} collapsed={true} />
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <ColumnLabel label="Value" textAlign={'right'} />
        </Form.Fieldset>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <ColumnLabel label="VAT" textAlign={'right'} />
        </Form.Fieldset>
      </Form.Row>

      <Form.Row>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <Label>Gross Goods</Label>
        </Form.Fieldset>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <Form.Field
            dataid="grossGoodsTotal"
            datatype="numeric"
            component={input.BlurTextField}
            readOnly={true}
            includeLabel={false}
            type={'currency'}
          />
        </Form.Fieldset>
      </Form.Row>

      <Form.Row>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <Label>Discount</Label>
        </Form.Fieldset>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <Form.Field
            dataid="overallDiscountValue"
            datatype="numeric"
            component={input.BlurTextField}
            readOnly={true}
            includeLabel={false}
            type={'currency'}
          />
        </Form.Fieldset>
      </Form.Row>

      <Form.Row>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <Label>Net Goods</Label>
        </Form.Fieldset>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <Form.Field
            dataid="nettGoodsTotal"
            datatype="numeric"
            component={input.BlurTextField}
            readOnly={true}
            includeLabel={false}
            type={'currency'}
          />
        </Form.Fieldset>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <Form.Field
            dataid="vatGoods"
            datatype="numeric"
            component={input.BlurTextField}
            includeLabel={false}
            readOnly={true}
            type={'currency'}
          />
        </Form.Fieldset>
      </Form.Row>
      <Form.Row>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <Label>Carriage</Label>
        </Form.Fieldset>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <Form.Field
            dataid="carriageTotalExVat"
            datatype="numeric"
            component={input.BlurTextField}
            readOnly={true}
            includeLabel={false}
            type={'currency'}
          />
        </Form.Fieldset>
        <Form.Fieldset cols={1 / 3} collapsed={true}>
          <Form.Field
            dataid="vatCarriage"
            datatype="numeric"
            component={input.BlurTextField}
            includeLabel={false}
            readOnly={true}
            type={'currency'}
          />
        </Form.Fieldset>
      </Form.Row>
      <VatBreakdown />
    </>
  );
};

export default ValueBreakdown;
